import { Directive, ElementRef, Input } from '@angular/core';
import { AddressModel } from '../../symbols';

@Directive({
  standalone: true,
  selector: '[addressStyle]'
})
export class AddressStyleDirective {

  constructor(private el: ElementRef) {
  }

  @Input() set address(value: AddressModel) {
    const vin = 'var(--vin)';
    const tulchin = 'var(--tulchin)';
    const litin = 'var(--litin)';
    const khmilnik = 'var(--khmilnik)';

    if (value?.country?.includes('Вінниц') || value?.city?.includes('Вінниц')) {
      this.el.nativeElement.style.background = vin;
    } else if (value?.country?.includes('Тульчин') || value?.city?.includes('Тульчин')) {
      this.el.nativeElement.style.background = tulchin;
    } else if (value?.country?.includes('Оратів') || value?.city?.includes('Оратів')) {
      this.el.nativeElement.style.background = tulchin;
    } else if (value?.country?.includes('Вапнярка') || value?.city?.includes('Вапнярка')) {
      this.el.nativeElement.style.background = tulchin;
    } else if (value?.country?.includes('Літин') || value?.city?.includes('Літин')) {
      this.el.nativeElement.style.background = litin;
    } else if (value?.country?.includes('Хмільни') || value?.city?.includes('Хмільни')) {
      this.el.nativeElement.style.background = khmilnik;
    }
  }


}
